import { render, staticRenderFns } from "./addtextCampaigns.vue?vue&type=template&id=bbdad784"
import script from "./addtextCampaigns.vue?vue&type=script&lang=js"
export * from "./addtextCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports